import React from "react";
import brandLogo from "../../assets/img/logo/favicon.png";
import brandCrest from "../../assets/img/logo/brand-crest.png";
import brandCrestDark from "../../assets/img/logo/brand-crest_dark.png";
import { MdOutlineContentCopy, MdWifiTethering, MdOutlineSettings, MdInfoOutline, MdFormatListBulleted, MdAcUnit } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { formatAmount } from "../../helpers/currency";




const CardItem = ({ card }) => {
  const navigate = useNavigate();

  const formatCardNumber = (cardNumber) => {
    if (!cardNumber) return "**** **** **** ****";
    return `${cardNumber?.slice(0, 4)} **** **** ${cardNumber?.slice(-4)}`;
  };

  const handleDetailsNavigation = () => {
    navigate(`/user/cards/card_option/${card.id}/details`);
  };

  const handleContinue = (cardId) => {
    navigate(`/user/cards/${cardId}`);
  }

  if (!card) return <p>Loading...</p>;

  const cardStatus = card.status || card.card_status || card.state || (card.is_active ? 'active' : 'inactive');
  const normalizedStatus = String(cardStatus).toLowerCase();
  const isPending = normalizedStatus === 'pending';
  const isFrozen = normalizedStatus === 'frozen' || normalizedStatus === 'blocked';

  // Don't render pending cards
  if (isPending) return null;

  return (
    <div className="card__container card-item-wrapper my-3 d-flex flex-column">
      {/* Card Preview */}
      
      <section className="card__preview card-item-preview">
        <div className="w-100 h-100">
          <div className="card__front card-item-front">
              <div className={`premium-card ${card.backgroundColor === "#F5F5F5" || card.backgroundColor === "#FFFFFF" || card.backgroundColor === "white" ? 'dark-logo' : ''}`}
                style={{
                  backgroundColor: card.backgroundColor,
                  backgroundImage: `url(${card.backgroundImage})`
                }}
              >
                <div className="premium-card-overlay"></div>
                
                {/* Frozen Overlay */}
                {isFrozen && (
                  <div className="premium-card-frozen-overlay">
                    <MdAcUnit className="snowflake-icon" />
                    <span className="frozen-text">CARD FROZEN</span>
                  </div>
                )}
                
                {/* Premium Card Top */}
                <div className="premium-card-top d-flex justify-content-between align-items-center w-100">
                    <div className="card-brand-text">
                        <img src={brandLogo} alt="logo" />
                    </div>
                    <span className={`card-status-badge ${normalizedStatus}`}>{cardStatus}</span>
                </div>
                
                {/* Premium Card Bottom */}
                <div className="premium-card-bottom d-flex justify-content-between align-items-end w-100 mt-auto">
                    <div className="cardholder-info d-flex flex-column align-items-start">
                        <div className="card-number d-flex flex-column align-items-start " style={{ marginBottom: '2rem' }}>
                          <span className="pan-text">
                            {formatCardNumber(card.last4 ? `**** **** **** ${card.last4}` : card.card_number)}
                          </span>
                          <span className="card-nickname m-0 p-0">{card.nickname}</span>
                        </div>
                        <span className="card-name" style={{ fontSize: '18px', fontWeight: '500' }}>
                          ${formatAmount(card?.virtual_card_account?.balance || 0)}
                        </span>
                    </div>
                    <div className="card-network-logo d-flex flex-column align-items-end">
                        <img src={card.cardLogo} width={50} alt="Card Type" />
                    </div>
                </div>
            </div>
          </div>
        </div>
      </section>

      {/* Card Actions */}
      <div className="card__actions d-flex flex-column gap-2 mt-4">
        <div className="d-flex justify-content-between gap-3">
          <button
            className="btn card-action-btn shadow-sm"
            onClick={handleDetailsNavigation}
          >
            <MdInfoOutline size={18} />
            <span>Details</span>
          </button>
          <button
            className="btn card-action-btn shadow-sm"
            onClick={() => handleContinue(card.id)}
          >
            <MdOutlineSettings size={18} />
            <span>Options</span>
          </button>
        </div>
        {/* <button 
          className="btn d-flex align-items-center justify-content-center gap-2 shadow-sm"
          onClick={() => navigate('activity-logs', { state: { cardId: card.id } })}
          style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid #E0E4EC', color: '#19064B', borderRadius: '12px', padding: '10px 0', fontWeight: '500', fontSize: '13px' }}
        >
          <MdFormatListBulleted size={18} />
          <span>Activity Logs</span>
        </button> */}
      </div>

    </div>
  );
};

export default CardItem;
